import React, { useContext, useEffect } from "react";
import Header from "../components/header/Header";
import DesktopView from "../components/desktopview/DesktopView";
import { useNavigate } from "react-router-dom";
import { SHOW_PIECES } from "../constants/piecesIcon";
import { useCookies } from "react-cookie";
import { MdDateRange } from "react-icons/md";
import MessageModals from "../components/modals/MessageModals";
import globalContext from "../Contexts/GlobalContext";

export default function ServicePlace() {
  const navigate = useNavigate();
  const [cookies, setCookies, removeCookies] = useCookies();
  const contextData = useContext(globalContext);
  useEffect(() => {
    if (cookies?.successMessageOfServicePlace) {
      contextData.setIsToastOpen(true);
      contextData.setToastMessage(cookies?.successMessageOfServicePlace);
      removeCookies("successMessageOfServicePlace");
    }
  });
  return (
    <>
      <div className="hidden min-[1024px]:block ">
        <DesktopView />
      </div>
      <div
        className="absolute w-full top-0 bottom-0 flex flex-col items-center justify-between bg-[#153038] min-[1024px]:hidden "
        onClick={() => {
          //   if (isSupportRequest === "true") {
          //     setIsSupportRequest("false");
          //   }
        }}
      >
        <Header relt="relative" />
        {contextData.isToastOpen && (
          <MessageModals
            setIsOpen={contextData.setIsToastOpen}
            message={contextData.toastMessage}
          />
        )}

        <div
          className={`w-[85vw] h-full flex flex-col items-start justify-start  gap-y-[2vw] `}
        >
          <div className="w-full flex flex-col items-center justify-center p-[2vw] my-[12vw] gap-y-[1vw]">
            <p className="font-font_primary_A text-[5.5vw] text-white font-bold">
              سرویس خودرو در محل
            </p>
            <p className="font-font_primary_A text-[3vw] text-white font-extralight">
              سرویس مد نظر خود رو خود را از فهرست زیر انتخاب نمایید
            </p>
            <div className="w-full flex items-center justify-center font-font_primary_A rounded-[0.9vw]  text-[3vw]  mt-[2vw]">
              <span className="bg-color-primary-B rounded-[0.9vw] py-[0.5vw] px-[2vw] ">
                این قابلیت تنها در تهران فعال می‌باشد
              </span>
            </div>
          </div>

          <div className="w-full flex items-center justify-between text-[4vw] text-[#FFF] font-font_primary_A  ">
            <div
              className="relative w-full min-h-[20vw] flex items-center justify-between border-[1px] rounded-[1.8vw] border-color-primary-C gap-x-[2vw]  px-[2vw] "
              onClick={() => {
                setCookies("servicePlaceType", "battery");
                navigate("/setServicePlaceDetails");
              }}
            >
              <div className="">
                {SHOW_PIECES("battery", "#FFF", "18vw", "18vw")}
              </div>
              <div className="h-full   flex flex-col items-center justify-center ">
                <span className="w-full flex items-center justify-start font-font_primary_A text-[3.5vw]  ">
                  سرویس باتری
                </span>
                <span className="w-full flex items-center justify-start  font-font_primary_A text-[2.5vw]   text-color-primary-C3">
                  تمامی سرویس‌های مربوط به باطری خودرو را می توانید در محل
                  درخواست دهید
                </span>
              </div>
            </div>
          </div>
          <div className="w-full flex items-center justify-between text-[4vw] text-[#FFF] font-font_primary_A  ">
            <div
              className="relative w-full min-h-[20vw] flex items-center justify-between border-[1px] rounded-[1.8vw] border-color-primary-C  gap-x-[2vw] px-[2vw]"
              onClick={() => {
                setCookies("servicePlaceType", "tire");
                navigate("/setServicePlaceDetails");
              }}
            >
              <div className="">
                {SHOW_PIECES("tire", "#FFF", "18vw", "18vw")}
              </div>
              <div className="h-full   flex flex-col items-center justify-center ">
                <span className="w-full flex items-center justify-start font-font_primary_A text-[3.5vw]bg-red-600  ">
                  سرویس لاستیک
                </span>
                <span className="w-full flex items-center justify-start  font-font_primary_A text-[2.5vw]   text-color-primary-C3">
                  تمامی سرویس‌های مربوط به لاستیک خودرو را می توانید در محل
                  درخواست دهید
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          className={`w-[85vw] h-full flex flex-col items-start justify-end  gap-y-[2vw] `}
        >
          <div className="w-full flex items-center justify-between text-[4vw] text-[#FFF] font-font_primary_A mb-[4vw] ">
            <div className="w-full flex items-center justify-between text-[4vw] text-[#FFF] font-font_primary_A  ">
              <div
                className="relative w-full min-h-[20vw] flex items-center justify-between border-[1px] rounded-[1.8vw] border-color-primary-C  gap-x-[2vw] px-[2vw]"
                onClick={() => {
                  setCookies("servicePlaceType", "tire");
                  navigate("/currentServicePlace");
                }}
              >
                <div className=" w-[25vw] flex items-center justify-center text-color-primary-B">
                  <MdDateRange size={30} />
                </div>
                <div className=" h-full w-full  flex flex-col items-center justify-center  ">
                  <span className="w-full flex items-center justify-start font-font_primary_A text-[3.5vw]  ">
                    تاریخچه
                  </span>
                  <span className="w-full flex items-center justify-start  font-font_primary_A text-[2.5vw]  text-color-primary-C3 ">
                    فهرست تاریخچه سرویس های فعلی و جاری شما
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
